import { DEFINITIONS } from './app-definitions';

export function isMaterialNumberInput(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }

  const normalizedValue = value.trim().toUpperCase();
  return DEFINITIONS.materialNumberPrefixes.some((prefix) => normalizedValue.startsWith(prefix));
}

